import { render, staticRenderFns } from "./pcHomeBanner.vue?vue&type=template&id=49ec9473&scoped=true"
import script from "./pcHomeBanner.vue?vue&type=script&lang=js"
export * from "./pcHomeBanner.vue?vue&type=script&lang=js"
import style0 from "./pcHomeBanner.vue?vue&type=style&index=0&id=49ec9473&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ec9473",
  null
  
)

export default component.exports